module.exports = __webpack_public_path__ + "img/tachometer-duotone.b7241bfa.svg";